export default "__VITE_ASSET__ByDLKTd7__"